/**
 * BenefitsSection Component
 * 
 * Displays the benefits of using RaveRemedy in a scrolling card format.
 */

import React from 'react';

import { BenefitsScroll } from './BenefitsScroll';

export const BenefitsSection: React.FC = () => {
  return (
    <section className="relative -mt-8 py-16 overflow-hidden" aria-labelledby="benefits-heading">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-purple-900/30 to-black" />
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557683316-973673baf926?auto=format&fit=crop&q=80')] opacity-5 mix-blend-overlay" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <header className="text-center mb-16">
          <h2 id="benefits-heading" className="text-4xl md:text-5xl font-bold mb-6 relative">
            <span className="gradient-text relative z-10">Why Choose RaveRemedy?</span>
            <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 w-48 h-1 bg-gradient-to-r from-[#ff00ff]/0 via-[#ff00ff]/50 to-[#ff00ff]/0"></div>
          </h2>
        </header>
        
        <BenefitsScroll />
      </div>
    </section>
  );
};